import { api } from "../../src/component/constent";


// ============================================================
// CURRENT MONTH
// ============================================================

export const getCreditJVCurrentMonth = () => {

    return api.get(
        "/entry/current-month"
    );

};


// ============================================================
// GET CREDIT JV
// ============================================================

export const getCreditJV = (
    month,
    year
) => {

    return api.get(
        "/entry/creditjv",
        {
            params: {
                month,
                year
            }
        }
    );

};


// ============================================================
// SAVE CREDIT JV
// ============================================================

export const saveCreditJV = (
    data
) => {

    return api.post(
        "/entry/creditjv",
        data
    );

};


// ============================================================
// DELETE CREDIT JV
// ============================================================

export const deleteCreditJV = (
    month,
    year
) => {

    return api.delete(
        "/entry/creditjv",
        {
            params: {
                month,
                year
            }
        }
    );

};